import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import CloseIcon from '@material-ui/icons/Close';
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import { 
    Card, CardHeader, CardContent, CardActions, 
    IconButton, Typography, Slide } from "@material-ui/core";
import { masterHandleClose, createMarkup, checkDailyEpoch } from "../common";

import { isMobile, isIOS, isAndroid, deviceDetect, deviceType } from 'react-device-detect';
import "../styles/masterStyles.css";

const DailyBanner = props => {
    if (props.auth && props.isDaily && checkDailyEpoch('sasp-dailyEpoch', 1)) {
        localStorage.removeItem('sasp-hideDaily');
        let classes = 'aua-top-banner anchor active background-blue';
        let qName = `SASP ${props.dailyQuestion.year} Question ${props.dailyQuestion.number}`

        if (isAndroid) { classes += ' android'} 
        else if (isIOS) { classes += ' ios'}
        
        return (
            <Slide mountOnEnter unmountOnExit
                direction="down"
                in={Boolean(props.isDaily)}
            >
                <div className={classes} id="DailyBanner">
                    <Card >
                        <CardHeader
                            title="Question of the Day"
                            subheader={qName}
                            action={
                                <IconButton
                                    className="firstButton"
                                    edge="start"
                                    aria-label="firstIcon"
                                    onClick={() => masterHandleClose('DailyBanner', 'active', 'inactive', 'sasp-hideDaily')}
                                    style={{backgroundColor: '#00567a', transform:"scale(0.5)"}}
                                >
                                    <CloseIcon className="headerIcons" />
                                </IconButton>
                            }
                            className=" padding-bottom-0"
                        />

                        <CardContent className=" padding-bottom-0 padding-top-0">
                            <Typography 
                                variant="body2" 
                                color="textSecondary" 
                                component="p"
                                dangerouslySetInnerHTML={createMarkup(props.dailyQuestion.text)}
                            />
                        </CardContent>

                        <CardActions className="padding-top-0" disableSpacing>
                            <Link
                                to={{
                                    pathname: "/SingleQuestionScreen",
                                    questionid: props.dailyQuestion.questionid,
                                    gameMode: 6
                                }}
                            >   
                                <IconButton
                                    className="firstButton"
                                    edge="start"
                                    aria-label="firstIcon"
                                >
                                    <PlayCircleFilledIcon />
                                </IconButton>
                            </Link>
                        </CardActions>
                    </Card>
                </div>
                
            </Slide>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth, isDaily, dailyQuestion } = state.auth;
    return { auth, isDaily, dailyQuestion };
};

const DailyBannerCard = connect(mapStateToProps)(withRouter(DailyBanner));

export { DailyBannerCard }
